module.exports = __webpack_public_path__ + "static/media/logo_black.d7cb91d4.svg";